import clsx from 'clsx';
import React, { ReactNode, useEffect, useState } from 'react'
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';
import { toast } from 'react-toastify';
import { Post } from 'src/apis/api';
import Loading from 'src/components/Loading';
import { CheckIcon, Close, InfoIcon } from 'src/icons/icons';
import { CrewListItem } from 'src/types';

export const CancelVisas = ({ crows, agentVisaId, onSuccessMutate, children }: { crows: CrewListItem[], agentVisaId: string, onSuccessMutate: Function, children?: ReactNode }) => {


    const { t } = useTranslation();

    const [step, setStep] = useState<'CONFIRM' | 'ENTER_MULTI_REASON' | 'ENTER_REASON' | 'SUCCESS' | undefined>(undefined)

    const [reasonMode, setReasonMode] = useState<'ONE' | 'MULTI'>('MULTI')


    const [desc, setDesc] = useState<string>('')

    const [dataToSend, setDataToSend] = useState<{ data: Array<{ crew_id: string, desc: string }> }>({ data: [] })


    const handleChangeCrewDesc = (crewId: string, desc: string) => {
        setDataToSend({ data: dataToSend.data.map(i => i.crew_id == crewId ? ({ ...i, desc }) : i) })
    }

    useEffect(() => {
        if (crows && step == 'ENTER_REASON') {
            setDataToSend({ data: crows.map(i => ({ crew_id: i.crew_id, desc: '' })) })
        }
    }, [crows, step])


    const { mutate: mutateCancel, isLoading: loadingOfCancel } = useMutation({
        mutationFn: () => {

            if (!agentVisaId) {
                toast.error(t('VisaIsNotExist'))
                return Promise.reject()
            }

            if (crows.length == 0) {
                toast.error(t('NoCrewSelected'))
                return Promise.reject()
            }

            return Post('/agent/visas/cancellation/store', {
                form: "store_cancellation_form",
                agent_visa_id: agentVisaId,
                // desc: desc,
                crews: reasonMode == 'MULTI' ? dataToSend.data : dataToSend.data.map(i => ({ crew_id: i.crew_id, desc }))

            })
        },
        mutationKey: ['Cancel-Visas'],
        onSuccess: (res: any) => {
            setStep('SUCCESS')
            toast.success(res?.msg);
            onSuccessMutate()
        },
        onError: (error: any) => {
            toast.error(error?.data?.message || error?.data?.msg);
        },
    })


    const handleCancel = () => {
        if (reasonMode == 'MULTI' && dataToSend.data.filter(i => typeof i.desc && i.desc.length > 0).length != dataToSend.data.length)
            return toast.info(t('CancelReasonOfCrewsIsEmpty'))

        else if (reasonMode == 'ONE' && !desc)
            return toast.info(t('CancelReasonIsEmpty'))
        mutateCancel()
    }

    const handleOpenModal = () => {

        if (crows.length == 0) {
            return toast.error(t('NoCrewSelected'))

        }

        setStep('CONFIRM')
    }

    useEffect(() => {
        if (step == 'ENTER_REASON') {
            setDesc('')
        }
    }, [step])

    console.log({ dataToSend })


    useEffect(() => {
        if (reasonMode == 'ONE')
            setDesc('')
        else setDataToSend({ data: crows.map(i => ({ crew_id: i.crew_id, desc: '' })) })
    }, [reasonMode])

    return (
        <>

            {children
                ? <div className='flex' onClick={handleOpenModal}>{children}</div>
                : <button
                    className='bg-rose-100 text-red p-2 rounded-lg  text-sm font-bold lg:min-w-32 flex flex-row items-center justify-center'
                    title={t('cancel')}
                    onClick={handleOpenModal}
                    disabled={loadingOfCancel}>
                    {loadingOfCancel
                        ? <Loading />
                        : t('cancel')}
                </button>}




            {step && createPortal(<div className={clsx('fixed top-0 left-0 h-full w-full backdrop-brightness-50 z-40 flex flex-row justify-center items-center', !step ? 'opacity-0' : ' opacity-100')}>
                <div className={clsx('flex flex-col gap-6 transition-all duration-300 bg-white max-w-[80vw] lg:max-w-[450px] rounded-2xl border p-4 relative max-h-[90vh] overflow-auto', !step ? 'translate-y-full' : 'translate-y-0')}>

                    <div className='absolute left-4 top-4 cursor-pointer' onClick={() => setStep(undefined)}> <Close color='gray' /></div>

                    {step == 'CONFIRM' && <>
                        <div className='border-red border p-2 aspect-square mx-auto rounded-[100px] bg-rose-100'>
                            <Close color='red' />
                        </div>
                        <span className='text-primary-400 text-lg text-center'>{t('AreYouSureToCancelVisa')}</span>
                        <div className='flex flex-row gap-1 flex-wrap bg-gray-100 rounded p-2 items-center'>
                            <InfoIcon className='text-gray-500 size-5' />
                            <span className='text-xs text-gray-700'>{t('AfterCancelVisaYouShouldOrderVisaAgain')}</span>

                        </div>

                        <div className='flex flex-row gap-2 items-center whitespace-nowrap'>
                            <button className='px-5 flex-1 py-2 text-center rounded-lg text-red' onClick={() => setStep('ENTER_REASON')}>{t('CancelVisa')}</button>
                            <button className='px-5 flex-1 py-2 text-center rounded-lg bg-primary-300 text-white' onClick={() => setStep(undefined)}>{t('DontCancelVisa')}</button>
                        </div>
                    </>}

                    {step == 'ENTER_REASON' && <>

                        <div className='border-red border p-2 aspect-square mx-auto rounded-[100px] bg-rose-100'>
                            <Close color='red' />
                        </div>
                        <span className='text-primary-400 text-center text-lg'>{t('YouAreCancelingVisas')}</span>

                        <label className='flex flex-row gap-2 items-start  bg-gray-100 rounded p-2 cursor-pointer'>
                            {/* <input checked={isConfirmedRules} onChange={({ target: { checked } }) => setConfirmRules(checked)} type='checkbox' className='outline-none rounded' /> */}

                            <ul className='text-xs text-gray-700 gap-4'>
                                <li className=''>{t('CancelDescription1')}</li>
                                <li className='mt-4'>{t('CancelDescription2')}</li>
                            </ul>
                        </label>

                       {crows?.length > 1 &&  <div className='flex flex-row gap-8 items-center text-sm'>

                            <label className='flex flex-row gap-2 items-center cursor-pointer'>
                                <input type='radio' checked={reasonMode == 'MULTI'} onChange={({ target: { checked } }) => checked ? setReasonMode('MULTI') : undefined} />
                                <span>{t('SeperateReasons')}</span>
                            </label>

                            <label className='flex flex-row gap-2 items-center cursor-pointer'>
                                <input type='radio' checked={reasonMode == 'ONE'} onChange={({ target: { checked } }) => checked ? setReasonMode('ONE') : undefined} />
                                <span>{t('OneReason')}</span>
                            </label>


                        </div>}


                        {reasonMode == 'MULTI' ? crows.map(i => <div key={i.crew_id} className='flex flex-col gap-4 items-start border rounded-lg p-2'>
                            <span className='text-sm'>{t('reasonForCancellation')} {t('visa')} {t('crew')} {i.crew.name} {i.crew.last_name} ({t('nationality')} {i.crew.nationality ?? '-'})</span>
                            <textarea
                                value={dataToSend?.data?.find(d => d.crew_id == i.crew_id)?.desc}
                                onChange={({ target: { value } }) => handleChangeCrewDesc(i.crew_id, value)}
                                className='border border-gray-500 rounded-lg resize-none p-2 outline-none text-sm h-24 flex-1 w-full'
                                placeholder={t('EnterReasonOfCancelation')}
                            /></div>)
                            : <textarea
                                value={desc}
                                onChange={({ target: { value } }) => setDesc(value)}
                                className='border border-gray-500 rounded-lg resize-none p-2 outline-none text-sm h-24 flex-1 w-full'
                                placeholder={t('EnterReasonOfCancelation')}
                            />}


                        <div className={clsx('flex flex-row gap-2 items-center whitespace-nowrap', (loadingOfCancel) && 'grayscale cursor-not-allowed')}>
                            <button disabled={loadingOfCancel} className='px-5 flex-1 py-2 text-center rounded-lg text-red flex flex-row  justify-center items-center' onClick={handleCancel}>{loadingOfCancel ? <Loading /> : t('CancelVisa')}</button>
                            <button disabled={loadingOfCancel} className='px-5 flex-1 py-2 text-center rounded-lg bg-primary-300 text-white' onClick={() => setStep(undefined)}>{t('DontCancelVisa')}</button>
                        </div>
                    </>}

                    {step == 'SUCCESS' && <>

                        <div className=' border-2 p-2 aspect-square mx-auto rounded-[100px] bg-green-100 border-green-500'>
                            <CheckIcon className='text-green-500 size-7' />
                        </div>
                        <span className='text-primary-400 text-center text-lg'>{t('CancelingWasSent')}</span>

                        <span className='text-sm text-gray-500'>{t('CallSupportForMoreInforamtion')}</span>

                        <button className='border border-primary-300 text-primary-300 rounded-lg font-bold  w-full p-2' onClick={() => setStep(undefined)}>{t('understand')}</button>

                    </>}


                </div>

            </div>, document.body)}
        </>

    )
}
